import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import emailjs from '@emailjs/browser';

function Contact() {
  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');

  const [nameError, setNameError] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [messageError, setMessageError] = useState<boolean>(false);

  const form = useRef<HTMLFormElement>(null);

  const sendEmail = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name !== '' && email !== '' && message !== '') {
      const templateParams = { name, email, message };

      emailjs.send(
        'service_b0arcep',
        'template_dyl6tnn',
        templateParams,
        'cnbooJ36B53sHe9AO'
      ).then(
        (response) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message envoyé avec succès !');
        },
        (error) => {
          console.log('FAILED...', error);
          alert("Erreur lors de l'envoi du message.");
        }
      );

      setName('');
      setEmail('');
      setMessage('');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>Contact Me</h1>
          <p>Got a data project waiting to be realized? Let's collaborate and make it happen!</p>

          <div style={{
            textAlign: 'left',
            marginBottom: '40px',
            backgroundColor: '#f8f9fa',
            padding: '20px 30px',
            borderRadius: '10px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
            color: '#333'
          }}>
            <p style={{ margin: '10px 0', fontSize: '1.1rem' }}>
              <strong>📧 Email :</strong>{' '}
              <a href="mailto:chahiri.abderrahmane.eng@gmail.com" style={{ color: '#5000ca', textDecoration: 'none' }}>
                chahiri.abderrahmane.eng@gmail.com
              </a>
            </p>
          </div>

          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className="contact-form"
          >
            <div className="form-flex">
              <TextField
                required
                fullWidth   // ✅ prend toute la largeur disponible
                label="Your Name"
                placeholder="What's your name?"
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={nameError}
                helperText={nameError ? 'Please enter your name' : ''}
              />
              <TextField
                required
                fullWidth   // ✅
                label="Email / Phone"
                placeholder="How can I reach you?"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                error={emailError}
                helperText={emailError ? 'Please enter your email or phone number' : ''}
              />
            </div>
            <TextField
              required
              fullWidth   // ✅
              label="Message"
              placeholder="Send me any inquiries or questions"
              multiline
              rows={10}
              className="body-form"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              error={messageError}
              helperText={messageError ? 'Please enter the message' : ''}
            />
            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;